import qs from 'query-string';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  AccountUserType,
  DefaultDashboardTypes,
  MutationType,
} from 'shared/types';
import request from 'utils/request';

export const useEditCurrentAccountUser = ({
  userId,
  callback,
}: {
  userId: string;
} & MutationType) => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: AccountUserType) => {
      const data: AccountUserType = await request(
        `/accounts/mine/users/${userId}`,
        payload,
        'PATCH',
      );
      return data;
    },
    {
      onSuccess: (response: AccountUserType) => {
        queryClient.setQueryData(
          ['account-user', response.user_id],
          () => response,
        );
        if (callback) callback(true, response);
      },
      onError: (error: any) => {
        if (callback) callback(false, error);
      },
    },
  );
};

export const getDashboardAuth = ({
  dashboard,
  callback,
  enabled = true,
}: { dashboard?: DefaultDashboardTypes } & MutationType) => {
  return useQuery(
    'analytics-dashboard',
    async () => {
      if (!dashboard) return;
      const newURL = qs.stringifyUrl({
        url: '/analytics/auth',
        query: { dashboard: dashboard.toLowerCase() },
      });
      const data = await request(newURL);
      return data;
    },
    {
      enabled,
      onSuccess: (response: any) => {
        if (callback) callback(true, response);
      },
      onError: (error: any) => {
        if (callback) callback(false, error);
      },
      staleTime: 0,
    },
  );
};
